/**
 * Community Tab Configuration
 * Entity-specific tab definitions for the Community page
 *
 * Each entity type gets a tailored set of tabs that reflects
 * their actual goals and connection types - not just hiring.
 */

// Icons are referenced by name and resolved in CommunityPage
export const communityTabConfig = {
  organization: {
    title: 'Community',
    subtitleTemplate: (entityName, vertical) =>
      `${entityName}'s professional network in the ${vertical} industry`,
    tabs: [
      { id: 'network', label: 'Network', icon: 'Network', countKey: null },
      { id: 'discover', label: 'Discover', icon: 'Sparkles', countKey: 'suggestions' },
      { id: 'talent', label: 'Talent', icon: 'UserPlus', countKey: 'talentSuggestions',
        filterEntities: ['individual'],
        description: 'Candidates and skilled professionals' },
      { id: 'partners', label: 'Partners', icon: 'Building2', countKey: 'partnerSuggestions',
        filterEntities: ['institute', 'university'],
        description: 'Training institutes and academic partners' },
      { id: 'connect', label: 'Connect', icon: 'UserPlus', countKey: 'connectCount' },
      { id: 'activity', label: 'Activity', icon: 'Bell', countKey: 'unread' },
      { id: 'goals', label: 'Goals', icon: 'Target', countKey: null }
    ]
  },

  institute: {
    title: 'Community',
    subtitleTemplate: (entityName, vertical) =>
      `${entityName}'s training network in ${vertical} development`,
    tabs: [
      { id: 'network', label: 'Training Ecosystem', icon: 'Network', countKey: null },
      { id: 'discover', label: 'Opportunities', icon: 'Sparkles', countKey: 'suggestions' },
      { id: 'clients', label: 'Clients', icon: 'Briefcase', countKey: 'clientSuggestions',
        filterEntities: ['organization'],
        description: 'Organizations seeking training' },
      { id: 'connect', label: 'Connect', icon: 'UserPlus', countKey: 'connectCount' },
      { id: 'activity', label: 'Activity', icon: 'Bell', countKey: 'unread' },
      { id: 'goals', label: 'Goals', icon: 'Target', countKey: null }
    ]
  },

  university: {
    title: 'Community',
    subtitleTemplate: (entityName, vertical) =>
      `${entityName}'s institutional network in ${vertical} education`,
    tabs: [
      { id: 'network', label: 'Institutional Network', icon: 'Network', countKey: null },
      { id: 'discover', label: 'Opportunities', icon: 'Sparkles', countKey: 'suggestions' },
      { id: 'connect', label: 'Partners', icon: 'UserPlus', countKey: 'connectCount' },
      { id: 'activity', label: 'Activity', icon: 'Bell', countKey: 'unread' },
      { id: 'goals', label: 'Goals', icon: 'Target', countKey: null }
    ]
  },

  individual: {
    title: 'Community',
    subtitleTemplate: (entityName, vertical) =>
      `Your professional network in the ${vertical} ecosystem`,
    tabs: [
      { id: 'network', label: 'My Network', icon: 'Network', countKey: null },
      { id: 'discover', label: 'Discover', icon: 'Sparkles', countKey: 'suggestions' },
      { id: 'connect', label: 'Connect', icon: 'UserPlus', countKey: 'connectCount' },
      { id: 'activity', label: 'Activity', icon: 'Bell', countKey: 'unread' },
      { id: 'goals', label: 'Goals', icon: 'Target', countKey: null }
    ]
  }
};

/**
 * Get tab config for an entity type
 */
export const getTabsForEntity = (entityType) => {
  return communityTabConfig[entityType] || communityTabConfig.individual;
};

/**
 * Filter suggestions by entity type filter from tab config
 */
export const filterSuggestionsByTab = (suggestions, tab) => {
  if (!tab?.filterEntities || tab.filterEntities.length === 0) return suggestions;
  return suggestions.filter(s =>
    tab.filterEntities.includes(s.suggested_entity_type?.toLowerCase())
  );
};

/**
 * Filter connections by entity type filter from tab config
 */
export const filterConnectionsByTab = (connections, tab) => {
  if (!tab?.filterEntities || tab.filterEntities.length === 0) return connections;
  return connections.filter(c =>
    tab.filterEntities.includes(c.connected_user_entity_type?.toLowerCase())
  );
};
